import React from 'react';
import { Edit2, Eye, EyeOff, Trash2 } from 'lucide-react';

const AdminPostList = ({ posts, loading, onEdit, onDelete, onTogglePublish }) => {
  if (loading && posts.length === 0) return <div className="text-center py-12 text-[#4E5359]" data-testid="admin-posts-loading">Nalagam…</div>;
  if (posts.length === 0) return <div className="text-center py-12 text-[#4E5359]" data-testid="admin-posts-empty">Ni blog člankov. Ustvarite prvega!</div>;
  return (
    <div className="space-y-3" data-testid="admin-post-list">
      {posts.map((post) => (
        <article key={post.id} className={`bg-white border ${post.published ? 'border-[#E2DACB]' : 'border-orange-200 bg-orange-50'} p-4 flex items-center gap-4`} data-testid={`admin-post-${post.id}`}>
          <img src={post.image} alt="" className="w-20 h-14 flex-shrink-0 object-cover bg-[#F6F2EA]" />
          <div className="flex-grow min-w-0">
            <div className="flex items-center gap-2"><h3 className="font-semibold text-[#15181C] truncate">{post.title}</h3>{!post.published && <span className="text-xs bg-orange-200 text-orange-800 px-2 py-0.5">Osnutek</span>}</div>
            <p className="text-sm text-[#4E5359] truncate">{post.excerpt}</p>
            <div className="flex gap-3 mt-1 text-xs text-[#7A5B28]"><span>{post.category}</span><span>•</span><span>{new Date(post.date).toLocaleDateString('sl-SI')}</span></div>
          </div>
          <div className="flex items-center gap-2 flex-shrink-0">
            <button onClick={() => onTogglePublish(post.id)} className="p-2 text-green-700" data-testid={`admin-toggle-post-${post.id}`} aria-label={post.published ? 'Skrij članek' : 'Objavi članek'}>{post.published ? <Eye className="w-4 h-4" /> : <EyeOff className="w-4 h-4" />}</button>
            <button onClick={() => onEdit(post)} className="p-2 text-[#7A5B28]" data-testid={`admin-edit-post-${post.id}`} aria-label="Uredi članek"><Edit2 className="w-4 h-4" /></button>
            <button onClick={() => onDelete(post.id)} className="p-2 text-red-600" data-testid={`admin-delete-post-${post.id}`} aria-label="Izbriši članek"><Trash2 className="w-4 h-4" /></button>
          </div>
        </article>
      ))}
    </div>
  );
};

export default AdminPostList;